import React from 'react';
import { Card } from 'react-bootstrap';

interface QuoteContent {
  text: string;
  attribution?: string;
}

interface QuoteBlockProps {
  block: {
    content?: QuoteContent;
  };
}

const QuoteBlock: React.FC<QuoteBlockProps> = ({ block }) => {
  if (!block.content) return null;

  return (
    <Card className="border-start border-4 border-primary bg-light">
      <Card.Body>
        <blockquote className="mb-0">
          <p className="font-italic mb-2">{block.content.text}</p>
          {block.content.attribution && (
            <footer className="blockquote-footer">
              {block.content.attribution}
            </footer>
          )}
        </blockquote>
      </Card.Body>
    </Card>
  );
};

export default QuoteBlock;
